var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNursesCallingDisable(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 38.414,
    height: 39.867,
    viewBox: "0 0 38.414 39.867",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "nurses-calling-disable",
    transform: "translate(-366.293 -653)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "nuses-calling",
    transform: "translate(0 274)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1463",
    "data-name": "Group 1463",
    transform: "translate(368 379)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Component_6_179",
    "data-name": "Component 6 \\u2013 179",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "nurse-svgrepo-com"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_965",
    "data-name": "Group 965"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1028",
    "data-name": "Path 1028",
    d: "M23.514,27.786c-1.441-.6-2.855-1.288-4.256-2a6.287,6.287,0,0,1-1.056-.958,1.239,1.239,0,0,0-.544-.3,1.167,1.167,0,0,1-1.091-1.092,7.356,7.356,0,0,1-.17-2.87.988.988,0,0,1,.587-.862c.771-.342,2.677-.716,3.439-1.079.567-.272.6-.5.4-1.158-.522-1.661-1.084-4.656-1.8-7.088a.609.609,0,0,0,.059-.206l.784-7.5a.56.56,0,0,0-.321-.609L12.885.015a.308.308,0,0,0-.192,0L6.027,2.062a.56.56,0,0,0-.32.609l.786,7.5a.6.6,0,0,0,.113.3c-.028.188-.061.375-.074.563a27.969,27.969,0,0,1-1.3,6.435c-.206.661-.17.886.4,1.158.763.363,2.667.737,3.439,1.079a.987.987,0,0,1,.588.862,7.347,7.347,0,0,1-.17,2.87,1.166,1.166,0,0,1-1.092,1.092,1.241,1.241,0,0,0-.543.3,6.321,6.321,0,0,1-1.055.958c-1.4.717-2.817,1.406-4.257,2C.322,28.7,1.155,30.3.8,33H25.255C24.9,30.3,25.729,28.7,23.514,27.786ZM12.788,1.112l6.2,1.9L18.3,9.547H7.275L6.591,3.016Z",
    transform: "translate(-0.796 0)",
    fill: "#9a9a9a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1029",
    "data-name": "Path 1029",
    d: "M22.305,9.263h1.71V7.546H25.73V5.837H24.015V4.12h-1.71V5.837H20.588V7.546h1.717Z",
    transform: "translate(-11.153 -1.433)",
    fill: "#9a9a9a"
  }))), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_2",
    "data-name": "Ellipse 2",
    cx: 7.035,
    cy: 7,
    rx: 7.035,
    ry: 7,
    transform: "matrix(1, 0.017, -0.017, 1, 22.053, 9.886)",
    fill: "#9a9a9a"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_966",
    "data-name": "Group 966",
    transform: "translate(26.308 12.978) rotate(9)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Component_2_1",
    "data-name": "Component 2 \\u2013 1",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "_2639886_phone_icon",
    "data-name": "2639886_phone_icon",
    d: "M4.6,4.213a.327.327,0,0,0-.35,0L3.7,4.561a.327.327,0,0,1-.387-.024,9.052,9.052,0,0,1-.778-.718,9.275,9.275,0,0,1-.678-.824.38.38,0,0,1-.023-.41L2.165,2a.384.384,0,0,0,0-.372L1.365.181A.338.338,0,0,0,.983.011,1.123,1.123,0,0,0,.452.349C-.166,1-.5,2.11,1.828,4.572S5.2,6.686,5.814,6.03a1.225,1.225,0,0,0,.32-.564.373.373,0,0,0-.16-.4Z",
    transform: "translate(-0.001 0.752) rotate(-7)",
    fill: "#9a9a9a"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_966-2",
    "data-name": "Group 966",
    transform: "translate(393.87 391.087) rotate(9)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Component_2_27",
    "data-name": "Component 2 \\u2013 27"
  }, /*#__PURE__*/React.createElement("path", {
    id: "_2639886_phone_icon-2",
    "data-name": "2639886_phone_icon",
    d: "M5.477,5.015a.389.389,0,0,0-.416,0l-.651.411A.389.389,0,0,1,3.949,5.4a10.776,10.776,0,0,1-.926-.855,11.041,11.041,0,0,1-.807-.981.453.453,0,0,1-.027-.489l.388-.69a.457.457,0,0,0,0-.442L1.625.216a.4.4,0,0,0-.454-.2,1.337,1.337,0,0,0-.632.4C-.2,1.2-.59,2.511,2.177,5.442S6.184,7.959,6.921,7.178A1.459,1.459,0,0,0,7.3,6.507a.445.445,0,0,0-.191-.479Z",
    transform: "translate(-0.001 0.895) rotate(-7)",
    fill: "#b7b7b7"
  })))), /*#__PURE__*/React.createElement("line", {
    id: "Line_295",
    "data-name": "Line 295",
    x1: 37,
    y2: 37,
    transform: "translate(367 655.16)",
    fill: "none",
    stroke: "#848484",
    strokeWidth: 2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNursesCallingDisable);
export default __webpack_public_path__ + "static/media/nurses-calling-disable.13a8b478b6c08b091800bfb706f0785c.svg";
export { ForwardRef as ReactComponent };